<!-- start of Table box -->
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
	<app-loader [showLoader]=showLoad></app-loader>
	<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
		<div class="o-stack__cell">
			<h5>{{sectiontitle}}</h5>
			<span>
				<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank" *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</span>
		</div>
	</div>
	<div class="c-portlet__content">
		<app-accordion-group>
			<app-accordion *ngFor="let creative of creatives; let i = index" [title]="creative.ad_headline" [index]="i + 1" [active]="i === 0"
			 [className]="creative.htmlClass">
				<div class="sem-creative-card-section-v2">
					<div class="sem-creative-card">
						<div class="sem-creative-heading">{{creative.ad_headline}}</div>
						<div class="sem-creative-card-link-container">
							<span class="sem-creative-card-text">AD</span>
							<cite class="sem-creative-card-link">{{creative.url}}</cite>
						</div>
						<span class="sem-creative-card-roboto"> {{creative.callExtension}}</span>
						<div *ngIf="isTypeString(creative?.description); else elseBlock" class="sem-creative-card-description sem-creative-card-roboto">
							{{creative?.description}}
						</div>
						<ng-template #elseBlock>
							<div class="sem-creative-card-description sem-creative-card-roboto">
								<p *ngFor="let desc of creative?.description">
									{{desc}}
								</p>
							</div>
						</ng-template>
					
						<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
							<div>
								<p>
									<span *ngFor="let callout of creative?.calloutsExtn; let i=index">{{callout}}<span [ngClass]="{'last_callout_class': i==creative?.calloutsExtn.length-1}">  &middot; </span></span>
								</p>
							</div>
						</div>
						  <div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
							  <div *ngFor="let snippet of creative?.structuredSnippetExtn">
								  <p>{{snippet?.type}}: {{snippet?.value}}</p>
							  </div>
						  </div>
						<div class="sem-creative-card-siteLinks-container">
							<div *ngFor="let siteLink of creative.siteLinks;" class="sem-creative-card-sitelinks">
								<h4>
									<a href="{{siteLink.link}}" target="_blank">{{siteLink.heading}}</a>
								</h4>
								<span class="sem-creative-card-roboto">{{siteLink.description}}</span>
							</div>
						</div>
						<div *ngIf="creative.location.trim().split(',').length>1">
							<span [ngStyle]="{'color' :  !last ?  '#1a0dab' : '#455a64'}" *ngFor="let location of creative.location.split(','); let last = last; let first = first;" class="sem-creative-card-location">
								<i class="fa fa-map-marker" aria-hidden="true" *ngIf="first" style="color: #575757;"></i> {{location}}<span *ngIf="!last">,</span></span>
						</div>
					</div>
					<div class="sem-creative-stats-section">
						<div class="card-long-block">
							<div class="card-long-content">
								<div>
									<div class="stats-div">
										<div class="stats-half-div">
											<div class="sub-head">Impressions</div>
											<div class="stats">{{creative.impressions | number}}</div>
										</div>
										<div class="stats-half-div">
											<!-- <div title='Average Position reporting is being removed 30 Sept 2019' *ngIf="(range === 'BEFORE' || range === 'WITHIN')">
													<div class="sub-head">Avg. Position</div>
													<div class="stats">{{creative.avg_position | number}}</div>
											</div> -->
										</div>
									</div>
									<div class="stats-div">
										<div class="stats-half-div">
											<div class="sub-head">Clicks</div>
											<div class="stats">{{creative.clicks | number}}</div>
										</div>
										<div class="stats-half-div">
											<div class="sub-head">Click Rate</div>
											<div class="stats">{{creative.clickthroughrate}}%</div>
										</div>
										<div class="clear"></div>
									</div>
									<div class="stats-div" *ngIf="!isGoliveNotStarted">
										<div  class="stats-half-div">
													<div class="sub-head">Abs. Top Imp.</div>
													<div class="stats">{{creative.absTopImpressionShare | number}}%</div>
										</div>
										<div  class="stats-half-div">
											<div class="sub-head">Top Imp.</div>
											<div class="stats">{{creative.topImpressionShare | number}}%</div>
										</div>
										<div *ngIf="(isGoliveNotStarted || isCutoffDate)" class="stats-half-div"></div>
											<div class="clear"></div>
									</div>
									<div class="stats-div" *ngIf="!isCutoffDate">
									<div  class="stats-half-div" >
										<div class="sub-head">Avg. Position</div>
										<div class="stats">{{creative.avg_position? (creative.avg_position | number): '--'}}</div>
								   </div>
								   <div class="stats-half-div"></div>
								   </div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</app-accordion>
			<div class="clear"></div>
		</app-accordion-group>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative">
				<div class="o-stack__cell">
					<h5>{{sectiontitle}}</h5>
				</div>
			</div>
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
<!--End of Table box -->
